import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  show() {
    this.menuTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }
}
